import type { MatrixClient } from "matrix-js-sdk";
import type { MeetingDetail } from "src/api/meetingsApi";
import { UserKeys } from "src/constants/userDetails";

type PortalUser = Record<string, unknown>;
type DescriptorMatrixClient = Pick<MatrixClient, "getRoom" | "getUserId">;

type AuthenticatedMeetingCallDescriptorOptions = {
    displayName: string;
    matrixClient: DescriptorMatrixClient;
    matrixRoomId: string;
    meeting: MeetingDetail;
    user: PortalUser;
};

export const createAuthenticatedMeetingCallDescriptor = ({
    displayName,
    matrixClient,
    matrixRoomId,
    meeting,
    user,
}: AuthenticatedMeetingCallDescriptorOptions) => ({
    type: "outbound",
    meetingUuid: meeting.meetingUuid,
    occurrenceUuid: meeting.occurrence.occurrenceUuid,
    callId: `meeting-${meeting.occurrence.occurrenceUuid}`,
    sender: matrixClient.getUserId(),
    chat: {
        uuid: meeting.chatUuid || meeting.meetingUuid,
        name: meeting.title,
        groupName: meeting.title,
        isGroupChat: true,
        matrixRoomId,
        matrixRoom: matrixClient.getRoom(matrixRoomId),
        meetingUrl: meeting.meetingUrl,
        meetingCanManage: meeting.canManage,
        meetingHostEmployeeUuid: meeting.hostEmployeeUuid,
        users: [{
            matrixUserId: matrixClient.getUserId(),
            firstName: user[UserKeys.FIRST_NAME] || displayName,
            lastName: user[UserKeys.LAST_NAME] || "",
        }],
    },
});
